import gql from 'graphql-tag';

export const LIST_SOCIUM_INTEGRATIONS = gql`
  query ListSociumIntegrations {
    listSociumIntegrations {
      _id
      name
      environment
      status
      apiKeyPrefix
      allowedRedirectDomains
      createdAt
      school {
        _id
        name
      }
    }
  }
`;

export const SOCIUM_INTEGRATION_STATS = gql`
  query SociumIntegrationStats($integrationId: MOID!) {
    sociumIntegrationStats(integrationId: $integrationId) {
      integrationId
      formationsCount
      sessionsCount
      usersProvisioned
      learnersCount
      modulesCount
    }
  }
`;

export const SOCIUM_DIAGNOSTICS = gql`
  query SociumDiagnostics($integrationId: MOID!, $type: String!, $ref: String!) {
    sociumDiagnostics(integrationId: $integrationId, type: $type, ref: $ref) {
      type
      ref
      status
      lines {
        label
        value
        level
      }
    }
  }
`;

export const SOCIUM_INTEGRATION_FORMATIONS = gql`
  query SociumIntegrationFormations($integrationId: MOID!) {
    sociumIntegrationFormations(integrationId: $integrationId) {
      externalRef
      lessonId
      title
      isPublished
      modulesCount
      sessionsCount
    }
  }
`;

export const SOCIUM_INTEGRATION_SESSIONS = gql`
  query SociumIntegrationSessions($integrationId: MOID!) {
    sociumIntegrationSessions(integrationId: $integrationId) {
      externalRef
      classId
      name
      formationExternalRef
      formationTitle
      participantsCount
    }
  }
`;

export const SOCIUM_INTEGRATION_LEARNERS = gql`
  query SociumIntegrationLearners($integrationId: MOID!) {
    sociumIntegrationLearners(integrationId: $integrationId) {
      externalUserRef
      userId
      firstName
      lastName
      email
      phoneNumber
      role
      classesCount
    }
  }
`;

export const SOCIUM_FORMATION_DETAIL = gql`
  query SociumFormationDetail($integrationId: MOID!, $externalRef: String!) {
    sociumFormationDetail(integrationId: $integrationId, externalRef: $externalRef) {
      title
      isPublished
      modules {
        title
        isPublished
      }
      sessions {
        externalRef
        name
        participantsCount
      }
    }
  }
`;

export const SOCIUM_SESSION_DETAIL = gql`
  query SociumSessionDetail($integrationId: MOID!, $externalRef: String!) {
    sociumSessionDetail(integrationId: $integrationId, externalRef: $externalRef) {
      name
      formationTitle
      participants {
        firstName
        lastName
        email
        phoneNumber
        status
      }
    }
  }
`;

export const SOCIUM_LEARNER_DETAIL = gql`
  query SociumLearnerDetail($integrationId: MOID!, $externalUserRef: String!) {
    sociumLearnerDetail(integrationId: $integrationId, externalUserRef: $externalUserRef) {
      firstName
      lastName
      email
      phoneNumber
      role
      memberships {
        sessionName
        formationTitle
        status
        progressPercent
        completedModules
        totalModules
      }
    }
  }
`;

export const CREATE_SOCIUM_INTEGRATION = gql`
  mutation CreateSociumIntegration($input: CreateSociumIntegrationInput!) {
    createSociumIntegration(input: $input) {
      apiKey
      integration {
        _id
        name
        environment
        status
        apiKeyPrefix
        allowedRedirectDomains
        createdAt
        school {
          _id
          name
        }
      }
    }
  }
`;

export const UPDATE_SOCIUM_INTEGRATION = gql`
  mutation UpdateSociumIntegration($input: UpdateSociumIntegrationInput!) {
    updateSociumIntegration(input: $input) {
      _id
      name
      allowedRedirectDomains
    }
  }
`;

export const ROTATE_SOCIUM_INTEGRATION_KEY = gql`
  mutation RotateSociumIntegrationKey($integrationId: MOID!) {
    rotateSociumIntegrationKey(integrationId: $integrationId) {
      apiKey
      integration {
        _id
        apiKeyPrefix
        status
      }
    }
  }
`;

export const SET_SOCIUM_INTEGRATION_STATUS = gql`
  mutation SetSociumIntegrationStatus($input: SetSociumIntegrationStatusInput!) {
    setSociumIntegrationStatus(input: $input) {
      _id
      status
    }
  }
`;
